define((require) => {
    "use strict";

    const Marionette = require("marionette");
    const template   = require("zbone/NoResultsItemView.tpl");

    /**
     * View class for when the user has applied a filter to a collection that returns no results.
     *
     * @class NoResultsItemView
     * @constructor
     *
     * @cfg {String} [noResultsMessage] The message to display in the view.
     * @cfg {String} [type] The type to display in the default message (could be Experiences/Images/Projects/Contents).
     */
    return Marionette.ItemView.extend({
        className: "no-result-message",

        template,

        ui: {
            message: ".message"
        },

        onRender() {
            const {noResultsMessage, type} = this.options;
            this.ui.message.text(noResultsMessage || `No ${type} found.`);
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/zbone/NoResultsItemView.js